'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ImageWrapper = require('../HelpComponents/ImageWrapper');var _ImageWrapper2 = _interopRequireDefault(_ImageWrapper);

var _UploadAssetWidget = require('../UploadAssetWidget.scss');var styles = _interopRequireWildcard(_UploadAssetWidget);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var PreviewSingleImage = function PreviewSingleImage(properties) {return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(styles.singleImage, styles.imageContainer, properties.singleImageClass),
        'data-id': properties.index },

      _react2.default.createElement(_ImageWrapper2.default, {
        id: properties.id,
        index: properties.index,
        image: properties.image,
        angle: properties.relativeAngle,
        uploadInProgress: properties.uploadInProgress }),

      _react2.default.createElement('span', {
          className: styles.rotate,
          onClick: properties.rotateImage },

        properties.deleteFileTitle),

      _react2.default.createElement('span', {
        className: styles.dot }),

      _react2.default.createElement('span', {
          className: styles.delete,
          onClick: properties.deleteImage },

        properties.rotateImageTitle)));}; // Styles
exports.default =



PreviewSingleImage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadAssetWidget/Preview/PreviewSingleImage.js
// module id = 2904
// module chunks = 0